const API_URL = 'https://onlineico.com/api';
//const API_URL = 'http://localhost/onlineico/api';

const adminHeaders = () => ({
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${localStorage.getItem('onlineico_token')}`
});

////////////////////////////
// PROJETS PUBLIC
////////////////////////////
export async function getProjects(filters = {}) {
    const params = new URLSearchParams();
    if (filters.status) params.append('status', filters.status);
    if (filters.search) params.append('search', filters.search);
    if (filters.sort)   params.append('sort', filters.sort);
    const r = await fetch(`${API_URL}/projects.php?${params}`);
    return r.json();
}

export async function getProject(slug) {
    const r = await fetch(`${API_URL}/project.php?slug=${slug}`);
    return r.json();
}

////////////////////////////
// SOUMISSION PROJET
////////////////////////////
export async function submitProject(data) {
    const token = localStorage.getItem('onlineico_token');
    const r = await fetch(`${API_URL}/submit.php`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            ...(token ? { 'Authorization': `Bearer ${token}` } : {})
        },
        body: JSON.stringify(data)
    });
    return r.json();
}

////////////////////////////
// VÉRIFICATION EMAIL
////////////////////////////
export async function verifyEmail(token) {
    const r = await fetch(`${API_URL}/verify-email.php?token=${token}`);
    return r.json();
}

////////////////////////////
// AUTH
////////////////////////////
export async function register(data) {
    const r = await fetch(`${API_URL}/auth/register.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
    });
    return r.json();
}

export async function login(data) {
    const r = await fetch(`${API_URL}/auth/login.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
    });
    return r.json();
}

export async function verifyAccount(token) {
    const r = await fetch(`${API_URL}/auth/verify-account.php?token=${token}`);
    return r.json();
}

////////////////////////////
// ESPACE CLIENT
////////////////////////////
export async function getMyProjects() {
    const token = localStorage.getItem('onlineico_token');
    const r = await fetch(`${API_URL}/auth/my-projects.php`, {
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
    });
    return r.json();
}

export async function getMyProject(slug) {
    const token = localStorage.getItem('onlineico_token');
    const r = await fetch(`${API_URL}/auth/update-project.php?slug=${slug}`, {
        headers: { 'Authorization': `Bearer ${token}` }
    });
    return r.json();
}

export async function updateProject(slug, data) {
    const token = localStorage.getItem('onlineico_token');
    const r = await fetch(`${API_URL}/auth/update-project.php?slug=${slug}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify(data)
    });
    return r.json();
}

////////////////////////////
// BOOSTS & OFFRES
////////////////////////////
export async function getProjectBoosts(slug) {
    const r = await fetch(`${API_URL}/boosts.php?slug=${slug}`);
    return r.json();
}

export async function consumeBoost(slug) {
    const token = localStorage.getItem('onlineico_token');
    const r = await fetch(`${API_URL}/auth/use-boost.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify({ slug })
    });
    return r.json();
}

export async function submitBoost(data) {
    const token = localStorage.getItem('onlineico_token');
    const r = await fetch(`${API_URL}/boosts.php`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            ...(token ? { 'Authorization': `Bearer ${token}` } : {})
        },
        body: JSON.stringify(data)
    });
    return r.json();
}

////////////////////////////
// PARAMÈTRES / TARIFS
////////////////////////////
export async function getSettings() {
    const r = await fetch(`${API_URL}/settings.php`);
    return r.json();
}

////////////////////////////
// ADMIN — STATS
////////////////////////////
export async function getAdminStats() {
    const token = localStorage.getItem('onlineico_token');
    const r = await fetch(`${API_URL}/admin/stats.php`, { headers: adminHeaders() });
    const text = await r.text();
    return JSON.parse(text);
}

////////////////////////////
// ADMIN — PROJETS
////////////////////////////
export async function getAdminProjects(status = 'all') {
    const r = await fetch(`${API_URL}/admin/projects.php?status=${status}`, { headers: adminHeaders() });
    return r.json();
}

export async function adminProjectAction(action, id, note = '', extra = '') {
    const r = await fetch(`${API_URL}/admin/projects.php`, {
        method: 'POST', headers: adminHeaders(),
        body: JSON.stringify({ action, id, note, extra })
    });
    return r.json();
}

export async function getAdminProjectPreview(id) {
    const r = await fetch(`${API_URL}/admin/project-preview.php?id=${id}`, { headers: adminHeaders() });
    return r.json();
}

////////////////////////////
// ADMIN — UTILISATEURS
////////////////////////////
export async function getAdminUsers() {
    const r = await fetch(`${API_URL}/admin/users.php`, { headers: adminHeaders() });
    return r.json();
}

export async function adminUserAction(action, id) {
    const r = await fetch(`${API_URL}/admin/users.php`, {
        method: 'POST', headers: adminHeaders(),
        body: JSON.stringify({ action, id })
    });
    return r.json();
}

////////////////////////////
// ADMIN — REVENUS
////////////////////////////
export async function getAdminRevenue() {
    const r = await fetch(`${API_URL}/admin/revenue.php`, { headers: adminHeaders() });
    return r.json();
}

////////////////////////////
// ADMIN — BOOSTS
////////////////////////////
export async function getAdminBoosts(status = 'pending') {
    const r = await fetch(`${API_URL}/admin/boosts.php?status=${status}`, { headers: adminHeaders() });
    return r.json();
}

export async function adminBoostAction(action, id) {
    const r = await fetch(`${API_URL}/admin/boosts.php`, {
        method: 'POST', headers: adminHeaders(),
        body: JSON.stringify({ action, id })
    });
    return r.json();
}

////////////////////////////
// ADMIN — PARAMÈTRES
////////////////////////////
export async function getAdminSettings() {
    const r = await fetch(`${API_URL}/admin/settings.php`, { headers: adminHeaders() });
    return r.json();
}

export async function updateSetting(key, value) {
    const r = await fetch(`${API_URL}/admin/settings.php`, {
        method: 'POST',
        headers: adminHeaders(),
        body: JSON.stringify({ key, value })
    });
    return r.json();
}

////////////////////////////
// QUESTS
////////////////////////////
export async function getAllEarnProjects() {
    const r = await fetch(`${API_URL}/earn.php`);
    return r.json();
}

export async function getPublicQuests(slug) {
    const token = localStorage.getItem('onlineico_token');
    const headers = token ? { 'Authorization': `Bearer ${token}` } : {};
    const r = await fetch(`${API_URL}/quests.php?slug=${slug}`, { headers });
    return r.json();
}

export async function getMyQuests(slug) {
    const token = localStorage.getItem('onlineico_token');
    const r = await fetch(`${API_URL}/auth/quests.php?slug=${slug}`, {
        headers: { 'Authorization': `Bearer ${token}` }
    });
    return r.json();
}

export async function createQuest(data) {
    const token = localStorage.getItem('onlineico_token');
    const r = await fetch(`${API_URL}/auth/quests.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify(data)
    });
    return r.json();
}

export async function deleteQuest(id) {
    const token = localStorage.getItem('onlineico_token');
    const r = await fetch(`${API_URL}/auth/quests.php`, {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify({ id })
    });
    return r.json();
}

////////////////////////////
// QUEST SUBMISSIONS
////////////////////////////
export async function submitQuestProof(quest_id, proof_url) {
    const token = localStorage.getItem('onlineico_token');
    const r = await fetch(`${API_URL}/auth/submit-quest.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify({ quest_id, proof_url })
    });
    return r.json();
}

export async function getUserQuestHistory() {
    const token = localStorage.getItem('onlineico_token');
    const r = await fetch(`${API_URL}/auth/submit-quest.php`, {
        headers: { 'Authorization': `Bearer ${token}` }
    });
    return r.json();
}

export async function getOwnerSubmissions(slug) {
    const token = localStorage.getItem('onlineico_token');
    const r = await fetch(`${API_URL}/auth/quest-submissions.php?slug=${slug}`, {
        headers: { 'Authorization': `Bearer ${token}` }
    });
    return r.json();
}

export async function reviewSubmission(id, action, reason = '') {
    const token = localStorage.getItem('onlineico_token');
    const r = await fetch(`${API_URL}/auth/quest-submissions.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify({ id, action, reason })
    });
    return r.json();
}

////////////////////////////
// CARD BANNER — UPLOAD CLIENT
////////////////////////////
export async function uploadCardBanner(slug, file) {
    const token = localStorage.getItem('onlineico_token');
    const formData = new FormData();
    formData.append('image', file);
    formData.append('slug', slug);
    const r = await fetch(`${API_URL}/auth/upload-card-banner.php`, {
        method: 'POST',
        headers: token ? { 'Authorization': `Bearer ${token}` } : {},
        body: formData
    });
    return r.json();
}

////////////////////////////
// ADMIN — CARD BANNERS
////////////////////////////
export async function getAdminCardBanners(status = 'pending') {
    const r = await fetch(`${API_URL}/admin/card-banners.php?status=${status}`, { headers: adminHeaders() });
    return r.json();
}

export async function adminCardBannerAction(project_id, action) {
    const r = await fetch(`${API_URL}/admin/card-banners.php`, {
        method: 'POST',
        headers: adminHeaders(),
        body: JSON.stringify({ project_id, action })
    });
    return r.json();
}

////////////////////////////
// ADMIN — RELANCE
////////////////////////////
export async function getRelanceProjects() {
    const r = await fetch(`${API_URL}/admin/relance.php?action=projects`, { headers: adminHeaders() });
    return r.json();
}

export async function getRelanceTemplates() {
    const r = await fetch(`${API_URL}/admin/relance.php?action=templates`, { headers: adminHeaders() });
    return r.json();
}

export async function saveRelanceTemplate(data) {
    const r = await fetch(`${API_URL}/admin/relance.php`, {
        method: 'POST',
        headers: adminHeaders(),
        body: JSON.stringify({ action: 'save_template', ...data })
    });
    return r.json();
}

export async function deleteRelanceTemplate(id) {
    const r = await fetch(`${API_URL}/admin/relance.php`, {
        method: 'DELETE',
        headers: adminHeaders(),
        body: JSON.stringify({ action: 'delete_template', id })
    });
    return r.json();
}

export async function sendRelance(project_ids, template_id) {
    const r = await fetch(`${API_URL}/admin/relance.php`, {
        method: 'POST',
        headers: adminHeaders(),
        body: JSON.stringify({ action: 'send', project_ids, template_id })
    });
    return r.json();
}

export async function getKycRelanceProjects() {
    const r = await fetch(`${API_URL}/admin/relance.php?action=kyc_projects`, { headers: adminHeaders() });
    return r.json();
}

export async function sendKycRelance(project_ids, template_id) {
    const r = await fetch(`${API_URL}/admin/relance.php`, {
        method: 'POST',
        headers: adminHeaders(),
        body: JSON.stringify({ action: 'send_kyc', project_ids, template_id })
    });
    return r.json();
}

export async function updatePreferences(data) {
    const token = localStorage.getItem('onlineico_token');
    const r = await fetch(`${API_URL}/auth/update-preferences.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...(token ? { 'Authorization': `Bearer ${token}` } : {}) },
        body: JSON.stringify(data)
    });
    return r.json();
}
